export { OZAKAZKA_ND as NAME,DefualtQuantity as DefualtQuantity, DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtOZakazkand';
export const PART_ROW_SAVED = 'Part Row Saved';
export const PART_ROW_EDITED = 'Part Row Edited';
export const PART_STOCK_SELECTED = 'Part Stock Selected';
export const PART_SELECTED = 'Part Selected'; 